import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=4239653c&scoped=true&"
import script from "./Tax.vue?vue&type=script&lang=js&"
export * from "./Tax.vue?vue&type=script&lang=js&"
import style0 from "./Tax.vue?vue&type=style&index=0&id=4239653c&prod&lang=scss&scoped=true&"
import style1 from "./Tax.vue?vue&type=style&index=1&id=4239653c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239653c",
  null
  
)

export default component.exports